import React from 'react';

import classes from './forBrokers.module.scss';

export const ForBrokers = () => {
  return (
    <div className={classes.ForBrokers}>
      <div className={classes.ForBrokersSection}>
        <div className={classes.ForBrokersLabel}>For Brokers</div>
        <div className={classes.ForBrokersTitle}>
          Automate your quoting. Close more deals. Cut overhead.
        </div>
        <div className={classes.ForBrokersDescription}>
          Monark gives brokers a fully automated quoting and enrollment engine — helping you:
        </div>
        
        <div className={classes.ForBrokersList}>
          <div className={classes.ForBrokersListItem}>
            • Reduce back-office costs
          </div>
          <div className={classes.ForBrokersListItem}>
            • Increase operational efficiency
          </div>
          <div className={classes.ForBrokersListItem}>
            • Drive <strong>30–50% more sales</strong> in supplemental products
          </div>
        </div>
      </div>
    </div>
  );
};